// LocationBadge.jsx
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import LocationIconSource from '../../img/ic_pin.svg';

export const LocationBadge = ({
  locationKey,
  fontSize,
  iconSize,
  isLocationKeyTranslationFetched,
  i18n,
  t,
  fetchTranslationByKey,
}) => {
  useEffect(() => {
    if (locationKey && !i18n.exists(locationKey)) {
      fetchTranslationByKey({ key: locationKey });
    }
  }, [locationKey, i18n, fetchTranslationByKey]);
  const locationPlaceholder = locationKey.replace(/location_/i, '');
  if (!locationKey) {
    return null;
  }
  return (
    <StyledLocationBadge iconSize={iconSize} fontSize={fontSize}>
      <img src={LocationIconSource} />
      <Location>
        {i18n.exists(locationKey) && isLocationKeyTranslationFetched
          ? t(locationKey)
          : locationPlaceholder}
      </Location>
    </StyledLocationBadge>
  );
};

LocationBadge.propTypes = {
  locationKey: PropTypes.string,
  iconSize: PropTypes.number,
  fontSize: PropTypes.number,
  isLocationKeyTranslationFetched: PropTypes.bool,
  fetchTranslationByKey: PropTypes.func,
  i18n: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

LocationBadge.defaultProps = {
  locationKey: '',
  iconSize: 12,
  fontSize: 12,
  isLocationKeyTranslationFetched: false,
  fetchTranslationByKey: () => null,
};

const StyledLocationBadge = styled.div`
  display: flex;
  align-items: center;
  color: inherit;
  font-size: ${({ fontSize }) => fontSize}px;
  > img {
    width: ${({ iconSize }) => iconSize}px;
    height: ${({ iconSize }) => iconSize}px;
    object-fit: contain;
  }
`;

const Location = styled.div`
  margin-left: 2px;
`;

export default withTranslation()(LocationBadge);
